// extracted by mini-css-extract-plugin
module.exports = {"price":"eR","currency":"eS","strikethrough":"eT","secondary":"eU"};